import { inject, Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TOAST_ALERTS_TOKEN, ToastAlertsAbstractService } from '@dataclouder/ngx-core';
import { DynamicComponentsService } from './dynamic-components.service';

@Injectable({
  providedIn: 'root',
})
export class DynamicComponentsBuilderService {
  #dialogService = inject(DialogService);
  #toastService = inject(TOAST_ALERTS_TOKEN);
  #dynamicComponentsService = inject(DynamicComponentsService);

  public openComponentBuilder(componentType: string, data: any = null): DynamicDialogRef | undefined {
    const componentToBuild = this.#dynamicComponentsService.getDynamicComponentBuilders(componentType);
    if (!componentToBuild) {
      console.error(`No component builder found for type: ${componentType}`);
      this.#toastService.error({ title: 'Error', subtitle: `Componente desconocido: ${componentType}` });
      return undefined;
    }
    const dialogRef: DynamicDialogRef = this.#dialogService.open(componentToBuild, {
      inputValues: {
        // inputValues was removed in newer PrimeNG versions, use 'data'
        inputs: data.inputs,
        id: data.id,
      },

      width: '80vw',
      header: 'Agregar componente',
      closable: true,
    });
    return dialogRef;
  }
}
